import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, spacing, borderRadius, typography } from '../constants/theme';
import Toast, { BaseToast, ErrorToast } from 'react-native-toast-message';

export const toastConfig = {
  success: (props: any) => (
    <BaseToast
      {...props}
      style={{
        borderLeftColor: colors.success,
        backgroundColor: '#FFFFFF',
        borderRadius: borderRadius.md,
        paddingHorizontal: spacing.md,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 3,
        minHeight: 60
      }}
      contentContainerStyle={{ paddingHorizontal: spacing.md }}
      text1Style={{
        fontSize: typography.fontSize.md,
        fontWeight: 'bold',
        color: colors.black
      }}
      text2Style={{
        fontSize: typography.fontSize.sm,
        color: colors.grey.dark
      }}
      renderLeadingIcon={() => (
        <View style={styles.iconContainer}>
          <Ionicons name="checkmark-circle" size={24} color={colors.success} />
        </View>
      )}
    />
  ),
  error: (props: any) => (
    <ErrorToast
      {...props}
      style={{
        borderLeftColor: colors.error,
        backgroundColor: '#FFFFFF',
        borderRadius: borderRadius.md,
        paddingHorizontal: spacing.md,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 3,
        minHeight: 60
      }}
      contentContainerStyle={{ paddingHorizontal: spacing.md }}
      text1Style={{
        fontSize: typography.fontSize.md,
        fontWeight: 'bold',
        color: colors.black
      }}
      text2Style={{
        fontSize: typography.fontSize.sm,
        color: colors.grey.dark
      }}
      renderLeadingIcon={() => (
        <View style={styles.iconContainer}>
          <Ionicons name="alert-circle" size={24} color={colors.error} />
        </View>
      )}
    />
  ),
  info: (props: any) => (
    <BaseToast
      {...props}
      style={{
        borderLeftColor: colors.primary,
        backgroundColor: '#FFFFFF',
        borderRadius: borderRadius.md,
        paddingHorizontal: spacing.md,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 3,
        minHeight: 60
      }}
      contentContainerStyle={{ paddingHorizontal: spacing.md }}
      text1Style={{
        fontSize: typography.fontSize.md,
        fontWeight: 'bold',
        color: colors.black
      }}
      text2Style={{
        fontSize: typography.fontSize.sm,
        color: colors.grey.dark
      }}
      renderLeadingIcon={() => (
        <View style={styles.iconContainer}>
          <Ionicons name="information-circle" size={24} color={colors.primary} />
        </View>
      )}
    />
  ),
};

const styles = StyleSheet.create({
  iconContainer: {
    paddingRight: spacing.sm,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
}); 